export const FEED_SOURCES = ['intercarg', 'arcelor', 'opentech'] as const;
export type FeedSource = typeof FEED_SOURCES[number];
export const FEED_NAMES: Record<FeedSource,string> = { intercarg: 'Intercarg', arcelor: 'Arcelor', opentech: 'Opentech' };
export const FEED_KINDS = ['baseline','added','changed','missing','schema','unchanged'] as const;
export type FeedKind = typeof FEED_KINDS[number];
export const FEED_KIND_LABELS: Record<FeedKind,string> = {
 baseline:'Referência inicial', added:'Novo na fonte', changed:'Alteração', missing:'Ausente na atualização', schema:'Campos da fonte', unchanged:'Sem mudanças',
};
export type FeedValue = string | number | null;
export interface FeedChange { key:string; label:string; before:FeedValue; after:FeedValue }
export interface FeedItem {
 id:string; source:FeedSource; kind:FeedKind; record_key:string|null;
 title:string; description:string; changes:FeedChange[];
 context:Record<string,FeedValue>; snapshot_id:string;
 generated_at:string; previous_generated_at:string|null; observed_at:string;
}
export interface FeedSourceStatus { source:FeedSource; mode:'snapshot'; generated_at:string|null; observed_at:string|null; row_count:number; summary:Record<string,number>; }
export interface FeedPage { rows:FeedItem[]; nextCursor:string|null; }
